import { useEffect, useState } from 'react';
import api from '../services/api';
import { formatApiError } from '../utils/errorMessage';

export default function PlatformPlans() {
  const [plans, setPlans] = useState([]);
  const [message, setMessage] = useState('');

  const load = () => {
    api.get('/billing/plans').then((response) => setPlans(response.data || [])).catch(() => setMessage('Could not load plans'));
  };

  useEffect(() => { load(); }, []);

  const save = async (plan) => {
    setMessage('');
    try {
      await api.put(`/billing/plans/${plan.key}`, {
        monthlyPrice: plan.monthlyPrice,
        annualPrice: plan.annualPrice,
        adviceEnabled: plan.adviceEnabled
      });
      setMessage(`${plan.name} saved`);
      load();
    } catch (error) {
      setMessage(formatApiError(error, 'Save failed'));
    }
  };

  const update = (key, field, value) => {
    setPlans((current) => current.map((plan) => (
      plan.key === key ? { ...plan, [field]: value } : plan
    )));
  };

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h2 className="text-lg font-semibold">Platform plans</h2>
      <p className="text-sm text-gray-600 mb-3">Price stays unset until you save one. Advice stays off and does not move money.</p>
      {plans.map((plan) => (
        <form key={plan.key} className="flex flex-wrap gap-2 items-end mb-3" onSubmit={(event) => { event.preventDefault(); save(plan); }}>
          <span className="font-medium w-24">{plan.name}</span>
          <label className="text-sm">Monthly
            <input className="block border rounded px-2 py-1" value={plan.monthlyPrice ?? ''} onChange={(event) => update(plan.key, 'monthlyPrice', event.target.value === '' ? null : event.target.value)} />
          </label>
          <label className="text-sm">Annual
            <input className="block border rounded px-2 py-1" value={plan.annualPrice ?? ''} onChange={(event) => update(plan.key, 'annualPrice', event.target.value === '' ? null : event.target.value)} />
          </label>
          {plan.key === 'business' && (
            <label className="text-sm flex items-center gap-2">
              <input type="checkbox" checked={Boolean(plan.adviceEnabled)} onChange={(event) => update(plan.key, 'adviceEnabled', event.target.checked)} />
              Advice
            </label>
          )}
          <button type="submit" className="bg-blue-600 text-white rounded px-3 py-1">Save</button>
        </form>
      ))}
      {message && <p className="text-sm">{message}</p>}
    </div>
  );
}
